interface Props {
  title: string;
  description: string;
  confirmLabel: string;
  confirmDanger?: boolean;
  submitting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  title,
  description,
  confirmLabel,
  confirmDanger = false,
  submitting = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
      onClick={() => {
        if (!submitting) onCancel();
      }}
    >
      <div
        className="bg-white rounded-xl w-full max-w-sm mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon + Title */}
        <div className="px-6 pt-6 pb-4">
          <div className="flex items-start gap-3">
            <div
              className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{
                backgroundColor: confirmDanger ? "rgba(220,38,38,0.08)" : "rgba(131,0,81,0.08)",
              }}
            >
              <i
                className={`text-base ${confirmDanger ? "ri-delete-bin-line" : "ri-question-line"}`}
                style={{ color: confirmDanger ? "#dc2626" : "#830051" }}
              ></i>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900 leading-snug">{title}</h3>
              <p className="text-xs text-gray-500 mt-1.5 leading-relaxed">{description}</p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-100 mx-6" />

        {/* Actions */}
        <div className="flex items-center justify-end gap-2.5 px-6 py-4">
          <button
            onClick={onCancel}
            disabled={submitting}
            className="px-4 py-1.5 text-sm text-gray-600 rounded-lg hover:bg-gray-100 cursor-pointer whitespace-nowrap transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className="inline-flex items-center gap-1.5 px-4 py-1.5 text-sm font-medium text-white rounded-lg cursor-pointer whitespace-nowrap transition-opacity hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
            style={{ backgroundColor: confirmDanger ? "#dc2626" : "#830051" }}
          >
            {submitting && <i className="ri-loader-4-line inline-block animate-spin"></i>}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
